import React from "react";
//import PropTypes from 'prop-types';
import { DropTarget } from "react-dnd";
import { connect } from "../../utils";
import { Image } from "./styled";
import Media from "./Media";

const target = {
  drop(props, monitor, component) {
    if (!monitor.didDrop()) {
      props.layoutState.insertOrMoveItem(
        props.id,
        props.children.length,
        monitor.getItem()
      );
    }
  }
};
const EditLayout = ({
  id,
  children,
  isOverCurrent,
  connectDropTarget,
  type,
  layoutState,
  readOnly
}) => {
  const {
    containerPadding,
    imageUrl,
    align,
    altText,
    action,
    width
  } = layoutState.getItemJS(id).props.values;
  let srcMobile = "";
  let srcDesktop = "";
  if (imageUrl) {
    srcMobile =
      imageUrl.urlMobile ||
      imageUrl.url ||
      "https://via.placeholder.com/940x400?text=940x400=CMS";
    srcDesktop =
      imageUrl.url ||
      imageUrl.urlMobile ||
      "https://via.placeholder.com/940x400?text=940x400=CMS";
  }
  return connectDropTarget(
    <div
      style={{
        boxSizing: "border-box",
        position: "relative",
        height: "auto",
        display: "flex",
        width: "100%",
        padding: containerPadding,
        flex: 1,
        action: action,
        justifyContent: align
      }}
    >
      <Media query="(max-width: 768px)">
        {matches =>
          matches ? (
            <Image
              src={srcMobile}
              alt={altText}
              style={{ width: width, height: "100%" }}
            />
          ) : (
            <Image
              src={srcDesktop}
              alt={altText}
              style={{ width: width, height: "100%" }}
            />
          )
        }
      </Media>
    </div>
  );
};

const LayoutContainer = DropTarget("ImageView", target, (conn, monitor) => ({
  connectDropTarget: conn.dropTarget(),
  isOverCurrent: monitor.isOver({ shallow: true })
}))(EditLayout);

export default connect(
  "layoutState",
  "readOnly"
)(LayoutContainer);



// WEBPACK FOOTER //
// ./src/editor/layout/components/Layout/DnDImage.js